module.exports = __webpack_public_path__ + "img/tank_sublike.0a1287aa.svg";